//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SEO from '~/mixins/SEO.js'
import JSONSCHEMA from '~/mixins/JSONSCHEMA.js'
export default {
    name: 'index',
    mixins: [SEO,JSONSCHEMA],
    data () {
        return {
            topScroll:false,
            doctorCurrentScroll:0,
        }
    },
    mounted() {
        setTimeout(() => {
            if (window.innerWidth > 992){
                window.addEventListener('scroll', this.stickProfile);
            }
        }, 500);
    },

    methods: {
        stickProfile () {
            let currentScroll = window.scrollY
            let body = document.body,
                html = document.documentElement;

            let height = Math.max(body.scrollHeight,body.offsetHeight,html.clientHeight,html.scrollHeight, html.offsetHeight);
            if (currentScroll > 10 && currentScroll < height - screen.height){
                if (currentScroll > this.doctorCurrentScroll){
                    this.topScroll = false
                } else {
                    this.topScroll = true
                }
                this.doctorCurrentScroll = currentScroll;
            }
        },
    },

    destroyed () {
        window.removeEventListener('scroll', this.stickNavbar);
    },

    async asyncData(context) {
  try {
    const response = await context.app.$api.fetchSingleDoctor(context.params.country, context.params.city, context.params.specialization, context.params.slug)
    return {
      page: response.content
    }
  } catch (e) {
    console.error(e)
    context.error({ statusCode: 404 })
  }
}

}
